<script lang="ts" setup>
interface Props {
  legend: ILegend[];
}

const props = defineProps<Props>();
</script>
<template>
  <div class="vue-chart-legend">
    <ul v-for="legend in props.legend">
      <li>
        <span class="chart-legend" :style="`background-color:${legend.color};`"></span>
        <span class="chart-legend-label-wrapper">
          <span class="chart-legend-label-text">{{ legend.label }}</span>
          <span class="chart-percentage">{{ legend.percentage }}%</span>
        </span>
      </li>
    </ul>
  </div>
</template>
